import { config } from '../utils/config.js';

export class StaffCallModal {
  constructor(i18n = null) {
    this.isVisible = false;
    this.i18n = i18n;
  }

  t(key) {
    return this.i18n ? this.i18n.t(key) : key;
  }

  show() {
    if (this.isVisible) return;
    
    this.isVisible = true;
    this.render();
    this.bindEvents();
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  hide() {
    this.isVisible = false;
    
    const modalContainer = document.getElementById('staff-call-modal');
    if (modalContainer) {
      modalContainer.remove();
    }
    
    // Restore body scroll
    document.body.style.overflow = '';
  }

  render() {
    const modalHtml = `
      <div id="staff-call-modal" class="staff-call-modal-container">
        <div class="modal-overlay"></div>
        
        <div class="staff-call-modal">
          <div class="staff-call-header">
            <i class="fas fa-bell staff-call-icon"></i>
            <h3>${this.t('callStaffAssistance')}</h3>
          </div>
          
          <div class="staff-call-content">
            <p>${this.t('needAssistance')}</p>
            <p class="staff-call-subtitle">${this.t('teamMemberNotified')}</p>
          </div>
          
          <div class="staff-call-actions">
            <button class="btn-secondary" id="staff-call-cancel">
              ${this.t('cancel')}
            </button>
            <button class="btn-primary" id="staff-call-confirm">
              <i class="fas fa-bell"></i>
              ${this.t('callStaffBtn')}
            </button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHtml);
  }

  bindEvents() {
    // Cancel button
    document.getElementById('staff-call-cancel')?.addEventListener('click', () => {
      this.hide();
    });

    // Confirm button
    document.getElementById('staff-call-confirm')?.addEventListener('click', () => {
      this.callStaff();
    });

    // Overlay click
    document.querySelector('#staff-call-modal .modal-overlay')?.addEventListener('click', () => {
      this.hide();
    });

    // ESC key
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        this.hide();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
  }

  async callStaff() {
    const confirmButton = document.getElementById('staff-call-confirm');
    const originalText = confirmButton.innerHTML;
    
    try {
      // Show loading state
      confirmButton.innerHTML = `<i class="fas fa-spinner fa-spin"></i> ${this.t('calling')}`;
      confirmButton.disabled = true;

      // Make API call to staff assistance endpoint
      const response = await fetch(`${config.getApiUrl()}/api/v1/device/notifications/staff-assistance`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        // Success - show confirmation
        this.showSuccess();
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Failed to call staff:', error);
      
      // Show error state
      confirmButton.innerHTML = '<i class="fas fa-exclamation-triangle"></i> Failed';
      confirmButton.classList.add('error');
      
      setTimeout(() => {
        confirmButton.innerHTML = originalText;
        confirmButton.disabled = false;
        confirmButton.classList.remove('error');
      }, 2000);
    }
  }

  showSuccess() {
    const modal = document.querySelector('.staff-call-modal');
    if (modal) {
      modal.innerHTML = `
        <div class="staff-call-success">
          <div class="success-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <h3>${this.t('staffCalledSuccess')}</h3>
          <p>${this.t('staffNotified')}</p>
          <button class="btn-primary" id="staff-call-success-ok">
            ${this.t('ok')}
          </button>
        </div>
      `;

      // Bind OK button
      document.getElementById('staff-call-success-ok')?.addEventListener('click', () => {
        this.hide();
      });

      // Auto-close after 3 seconds
      setTimeout(() => {
        if (this.isVisible) {
          this.hide();
        }
      }, 3000);
    }
  }
}